<template>
    <div id="app">
        <div>
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
const LANG_MAP = {
    'en-US': 'en',
    'zh-CN': 'zh-CN',
    'ar-SA': 'ar',
    'es-ES': 'es',
    'pt-PT': 'pt-PT',
    'ru-RU': 'ru'
};

export default {
    name: 'App',
    watch: {
        // 切语言（PC 端不刷新页面）→ 同步 <html lang> 与页面 <title>
        '$i18n.locale'() {
            this.syncMeta();
        },
        // 路由切换 → 同步对应页面 <title>
        '$route'() {
            this.syncMeta();
        }
    },
    created() {
        this.syncMeta();
    },
    methods: {
        syncMeta() {
            const locale = this.$i18n.locale;
            document.documentElement.lang = LANG_MAP[locale] || 'en';
            const titleKey = (this.$route.meta && this.$route.meta.titleKey) || 'page_title.home';
            const title = this.$t(titleKey);
            if (title) {
                document.title = title;
            }
            // 同步各页 meta description（多语言、按路由）
            const descKey = (this.$route.meta && this.$route.meta.descKey) || 'page_desc.home';
            const desc = this.$t(descKey);
            if (desc) {
                let metaDesc = document.querySelector('meta[name="description"]');
                if (!metaDesc) {
                    metaDesc = document.createElement('meta');
                    metaDesc.name = 'description';
                    document.head.appendChild(metaDesc);
                }
                metaDesc.content = desc;
            }
        }
    }
}
</script>

<style>
body {
    background-color: var(--page-bg);
}
html{
    margin: 0;
    padding: 0;
}
* {
    margin: 0;
    padding: 0;
}
::v-deep .el-header{
    margin: 0;
    padding: 0;
}
/*超出2行隐藏*/
.two-line-ellipsis {
    overflow: hidden;      /* 超出隐藏 */
    display: -webkit-box;  /* 旧版弹性盒模型 */
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2; /* 最多 3 行 */
    line-clamp: 2;         /* 标准写法（未来兼容） */
    text-overflow: ellipsis;
}
/*超出三行隐藏*/
.three-line-ellipsis {
    overflow: hidden;      /* 超出隐藏 */
    display: -webkit-box;  /* 旧版弹性盒模型 */
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3; /* 最多 3 行 */
    line-clamp: 3;         /* 标准写法（未来兼容） */
    text-overflow: ellipsis;
}
</style>
